import { FormlyFieldConfig } from '@ngx-formly/core';
import { Injectable, Injector } from '@angular/core';
import { RenderFormService } from './render-form.service';
import { RenderSectionService } from './render-section.service';
import { RenderQuestionService } from './render-question.service';
import {RenderArrayService } from './render-array-service';
import { v4 as uuidv4 } from 'uuid';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { CloneService } from '../clone/clone.service';
import { WidgetsConfigController, WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsArrayModel } from 'src/app/models/widgets/widgets-array.model';
import { WidgetsTextModel } from 'src/app/models/widgets/widgets-text.model';
import { WidgetsFieldModel } from 'src/app/models/widgets/widgets-field.model';
import { RenderRowService } from './render-row.service';
import { RenderColumnService } from './render-column.service';
import { Logger } from 'src/app/core/logger';
import { FieldOptionModel } from 'src/app/models/widgets/field-option.model';
import { RenderRadioService } from './render-radio.service';
import { RenderFieldService } from './render-field.service';
import { WidgetsRadioModel } from 'src/app/models/widgets/widgets-radio.model';
import { RenderTextService } from './render-text.service';
import { RenderCheckboxService } from './render-checkbox.service';
import { AbstractRender } from 'src/app/abstract/render.abstract';

@Injectable({
  providedIn: 'root',
})
export class RenderService {
  private counter : number = 0;
  constructor(
    private injector: Injector,
    private logger: Logger,
  ) {}

  /**
   * Recursive render method
   *
   * @param widget A layout node
   * @param config Formly field config array
   * @param widgetRoot Root of the layout
   * @param formlyRoot Root of the FormlyFieldConfig
   * @param isInsideQuestion True if we are rendering a subtree inside a question
   * @param isRecursive True if we want to traverse the tree to the bottom. False if we just want to render a node.
   */
  render(
    widget: WidgetsAbstract,
    config: FormlyFieldConfig[],
    widgetRoot: WidgetsAbstract,
    formlyRoot: FormlyFieldConfig,
    isInsideQuestion: boolean,
    isRecursive: boolean
  ) {
    try {      
      const renderClass = WidgetsConfigController.get(widget.widgetType)?.render;
      const renderer: AbstractRender = this.injector.get<AbstractRender>( renderClass );
      if (renderer) {
        renderer.render(widget,
          config,
          widgetRoot,
          formlyRoot,
          isInsideQuestion,
          isRecursive);
      }
    } catch (error) {
      this.logger.warn("RenderService "+error);
    }
  }
  
  getCounter(){
    this.counter++;    
    return this.counter ;
  }

}
